import { WithinResult } from '../../../tests/types/WithinResult';

export const sliceContainerTestId = 'slice-container';
/**
 * Gets slice container.
 */
export const getSliceContainer = (screen: WithinResult) => screen.getByTestId(sliceContainerTestId);
